// extracted by mini-css-extract-plugin
export var container = "_ic-0";